export default "__VITE_ASSET__DD2LAi0N__"